import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleSwitchComponent } from './toggle-switch.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ToggleSwitchComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [
    ToggleSwitchComponent,
  ],
  providers: [
    TranslatePipe,
  ]
})
export class ToggleSwitchModule { }
